export type DifficultyLevel = 'easy' | 'moderate' | 'hard' | 'strenuous';

export type DifficultyReview = {
  review?: {
    difficulty: number | null;
  };
};

export default function getDifficultyLevel(difficulty?: number): DifficultyLevel | undefined {
  if (!difficulty) {
    return undefined;
  }

  if ([1, 2].includes(difficulty)) {
    return 'easy';
  }

  if ([3, 4].includes(difficulty)) {
    return 'moderate';
  }

  if ([5, 6].includes(difficulty)) {
    return 'hard';
  }

  if ([7, 8].includes(difficulty)) {
    return 'strenuous';
  }

  return undefined;
}
